import { render } from "./EditableTextBlock.vue?vue&type=template&id=afd4f17c"
import script from "./EditableTextBlock.vue?vue&type=script&lang=js"
export * from "./EditableTextBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__